import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function AccountSetup() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [pw, setPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirmPw) {
      setErr('Passwords do not match');
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      const r = await api.users.accountSetup({ token, password: pw });
      setOk(`Password set for ${r.email}. You can now sign in.`);
      setTimeout(() => navigate('/login'), 1500);
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
        <div className="max-w-sm bg-white rounded-lg shadow p-6 text-sm text-slate-700">
          Missing setup token. Use the link your admin sent you.
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-lg shadow p-6 space-y-4">
        <h1 className="text-xl font-semibold text-cathay-700">Set your password</h1>
        <p className="text-sm text-slate-600">
          Choose a password of at least 10 characters. After this you can sign in normally.
        </p>
        <input
          type="password"
          required
          minLength={10}
          placeholder="New password"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          className="w-full border border-slate-300 rounded px-3 py-2"
        />
        <input
          type="password"
          required
          placeholder="Confirm new password"
          value={confirmPw}
          onChange={(e) => setConfirmPw(e.target.value)}
          className="w-full border border-slate-300 rounded px-3 py-2"
        />
        {err && <div className="text-sm text-red-600">{err}</div>}
        {ok && <div className="text-sm text-green-700">{ok}</div>}
        <button
          disabled={busy}
          className="w-full bg-cathay-500 hover:bg-cathay-600 disabled:opacity-60 text-white py-2 rounded"
        >
          Set password
        </button>
      </form>
    </div>
  );
}
